import type { AnimationEventHandler, FC, PropsWithChildren } from 'react';
import React from 'react';

import { cnTextarea } from '../Textarea.cn';

import './Textarea-Hint.css';

export type TextareaHintProps = PropsWithChildren<{
    leave: boolean;
    onAnimationEnd: AnimationEventHandler<HTMLSpanElement>;
}>;

export const TextareaHint: FC<TextareaHintProps> = ({ leave, onAnimationEnd, children }) => (
    <span className={cnTextarea('Hint', { leave })} onAnimationEnd={onAnimationEnd}>
        {children}
    </span>
);
